import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesArticulos() {
  const { user } = useContext(AuthContext);

  const SECCIONES = [
    { section: "Modelos", items: [
      { label: "Modelos", icon: "fas fa-tshirt", color: "#3b82f6", href: "/ListadoArticulos", desc: "Alta y listado de modelos", enabled: !!user.menu_articulos },
    ]},
    { section: "Catálogos", items: [
      { label: "Lineas", icon: "fas fa-bars", color: "#6366f1", href: "/Lineas", desc: "Lineas de producto", enabled: !!user.menu_articulos },
      { label: "Marcas", icon: "far fa-copyright", color: "#8b5cf6", href: "/Marcas", desc: "Marcas registradas", enabled: !!user.menu_articulos },
      { label: "Familias", icon: "fas fa-users", color: "#14b8a6", href: "/Familias", desc: "Familias de modelos", enabled: !!user.menu_articulos },
      { label: "Colecciones", icon: "fas fa-calendar-alt", color: "#f59e0b", href: "/Colecciones", desc: "Colecciones por temporada", enabled: !!user.menu_articulos },
      { label: "Composiciones", icon: "fas fa-percent", color: "#06b6d4", href: "/Composiciones", desc: "Composicion textil", enabled: !!user.menu_articulos },
      { label: "Colores", icon: "fas fa-palette", color: "#ec4899", href: "/Colores", desc: "Catalogo de colores", enabled: !!user.menu_articulos },
      { label: "Tallas", icon: "fas fa-ruler", color: "#64748b", href: "/Tallas", desc: "Catalogo de tallas", enabled: !!user.menu_articulos },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Modelos"
      descripcion="Catalogo de modelos y sus atributos"
      icono="fas fa-tshirt"
      color="#3b82f6"
      secciones={SECCIONES}
    />
  );
}

export default BotonesArticulos;
